import { create } from 'zustand';

export const useCameFromAuthFallback = create<{
  cameFromAuthFallback: boolean;
  setCameFromAuthFallback: (value: boolean) => void;
}>((set) => ({
  cameFromAuthFallback: false,
  setCameFromAuthFallback: (value) => set({ cameFromAuthFallback: value }),
}));
